import { useState } from "react";
import LZOTabela from "./LZOTabela";
import DodavanjePostojeciTabela from "./DodavanjePostojeciTabela";
import LZOTabelaAzuriranje from "./LZOTabelaAzuriranje";
import { useGlobalContext } from "../../../../../Context/Context";

const LicnaZastitnaOprema = ({ selectedCompany }) => {
  // // ""-pocetna, "DODAVANJE_POSTOJECI", "AZURIRANJE"
  // const [currentState, setCurrentState] = useState("");
  const { folderDokumentCurrentState } = useGlobalContext();

  return (
    <>
      {folderDokumentCurrentState === "" && <LZOTabela />}
      {folderDokumentCurrentState === "DODAVANJE_POSTOJECI" && (
        <DodavanjePostojeciTabela />
      )}
      {folderDokumentCurrentState === "AZURIRANJE" && <LZOTabelaAzuriranje />}
    </>
  );
};

export default LicnaZastitnaOprema;
